import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Footer } from '../Common';
import Accessories from '../../Common/Accessories';
import bannerBg from '../../../../assets/abc-se/school-shop/banner.jpg';
import bulkPartyoverallen from '../../../../assets/abc-se/accessories/party-overall.jpg';
import bulkFlakoverallen from '../../../../assets/abc-se/accessories/standard-overall.jpg';
import accSprayCans from '../../../../assets/abc-se/products/acc-spray-cans.jpg';
import accMarkers from '../../../../assets/abc-se/products/acc-markers.jpg';
import accPaintGirl from '../../../../assets/abc-se/products/acc-paint-girl.jpg';
import accConfettiGirl from '../../../../assets/abc-se/products/acc-confetti-girl.jpg';
import accPointtrojen from '../../../../assets/abc-se/products/acc-pointtrojen.jpg';
import accSprayCans2 from '../../../../assets/abc-se/products/acc-spray-cans-2.jpg';
import accSprayCans3 from '../../../../assets/abc-se/products/acc-spray-cans-3.jpg';
import accSprayCans4 from '../../../../assets/abc-se/products/acc-spray-cans-4.jpg';

/* ── Product catalog (ABC-SE) ── */
const BULK_PRODUCTS = [
  { id: 'bulk-1', slug: 'partyoverallen', image: bulkPartyoverallen, imageAlt: 'Partyoverallen', title: 'PARTYOVERALLEN', price: '159:-' },
  { id: 'bulk-2', slug: 'flakoverallen', image: bulkFlakoverallen, imageAlt: 'Flakoverallen', title: 'FLAKOVERALLEN', price: '159:-' },
];

const ACCESSORY_PRODUCTS = [
  { id: 'acc-1', slug: 'sprayfarg', image: accSprayCans, imageAlt: 'Sprayfärg', title: 'SPRAYFÄRG', price: '59:-' },
  { id: 'acc-2', slug: 'tuschpennor', image: accMarkers, imageAlt: 'Tuschpennor', title: 'TUSCHPENNOR', price: '79:-' },
  { id: 'acc-3', slug: 'textilfarg', image: accPaintGirl, imageAlt: 'Textilfärg', title: 'TEXTILFÄRG', price: '49:-' },
  { id: 'acc-4', slug: 'konfetti-kit', image: accConfettiGirl, imageAlt: 'Konfetti Kit', title: 'KONFETTI KIT', price: '39:-' },
];

const BOTTOM_PRODUCTS = [
  { id: 'bot-1', slug: 'pointtrojen', image: accPointtrojen, imageAlt: 'Pointtröjen', title: 'POINTTRÖJEN', price: '89:-' },
  { id: 'bot-2', slug: 'sprayfarg-set', image: accSprayCans2, imageAlt: 'Sprayfärg Set', title: 'SPRAYFÄRG SET', price: '179:-' },
  { id: 'bot-3', slug: 'sprayfarg-neon', image: accSprayCans3, imageAlt: 'Sprayfärg Neon', title: 'SPRAYFÄRG NEON', price: '69:-' },
  { id: 'bot-4', slug: 'sprayfarg-metallic', image: accSprayCans4, imageAlt: 'Sprayfärg Metallic', title: 'SPRAYFÄRG METALLIC', price: '99:-' },
];

const TABS = [
  { key: 'alle', label: 'Alla' },
  { key: 'overalls', label: 'Overalls' },
  { key: 'accessories', label: 'Accessories' },
];

const ABCSEAccessories = () => {
  const navigate = useNavigate();
  return (
    <Accessories
      brand="ABC"
      Header={Header}
      Footer={Footer}
      bannerTag="Water resistant and Highly Durable"
      bannerTitle="Overalls & More"
      bannerImage={bannerBg}
      tabs={TABS}
      showTabs={false}
      bulkProducts={BULK_PRODUCTS}
      accessoryProducts={ACCESSORY_PRODUCTS}
      bottomProducts={BOTTOM_PRODUCTS}
      fullwidth={{
        subtitle: 'MORE THAN 15,000 CUSTOMERS ANNUALLY',
        mainCopy: 'We offer fast delivery and attractive packaging solutions, and you can order safely and securely with over 100 years of experience.',
        tags: ['Promo message', 'Promo message', 'Promo message'],
      }}
      onBulkClick={(slug) => navigate(`/clothing/abc-se/bulk-product/${slug}`)}
      onAccessoryClick={(slug) => navigate(`/clothing/abc-se/product-details/${slug}`)}
    />
  );
};

export default ABCSEAccessories;
